import { render, staticRenderFns } from "./jp-sso.vue?vue&type=template&id=58bc068b"
import script from "./jp-sso.vue?vue&type=script&lang=js"
export * from "./jp-sso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports